const profileRoutes = [
  {
    path: "",
    exact: false,
    redirect: (to) => ({
      name: "profileSecurity",
      query: to.query,
    }),
  },
  {
    path: "security",
    name: "profileSecurity",
    exact: false,
    component: () => import("@/views/Profile/Security"),
  },
];

export default profileRoutes;
